import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "events-management-staff" }
const _hoisted_2 = {
  key: 0,
  class: "staff-list"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Staff List:", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "There is no staff in your event", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ATag = _resolveComponent("ATag")!
  const _component_AInputSearch = _resolveComponent("AInputSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Checkin Staff for \"" + _toDisplayString(_ctx.event?.metadata?.title) + "\"", 1),
    (_ctx.event !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.event !== null && _ctx.event?.checkin_staff.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.checkin_staff, (item) => {
                  return (_openBlock(), _createBlock(_component_ATag, {
                    item: item,
                    closable: "",
                    onClose: ($event: any) => (_ctx.removeStaff(_ctx.id, item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["item", "onClose"]))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
          _createElementVNode("p", null, [
            _createVNode(_component_AInputSearch, {
              placeholder: "Add Staff",
              "enter-button": "Add",
              size: "large",
              onSearch: _ctx.addStaff
            }, null, 8, ["onSearch"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}